import firebase from "@/plugins/firebase"
import Result from "@/domain/result"

let addReserves = []
let deleteReserves = []

export default class ResultRepository {
  static findByUser(user) {
    return new Promise(async (resolve, reject) => {
      if (!user.id) {
        reject(new Error("user.id is null"))
      }

      const resultRef = firebase.firestore().collection("users").doc(user.id).collection("results")

      // results get
      let results = await resultRef.get()
      if (results.length <= 0) { reject(new Error(`resultsは見つかりませんでした。`)) }
      let resultsData = results.docs.flatMap(doc => { return { id: doc.id, data: doc.data() } })

      // results validate
      let resultsValidateResult = Result.validate(resultsData)
      if (resultsValidateResult.isInvalid) { reject(resultsValidateResult.errors) }

      console.log("resultsData: ")
      console.log(resultsData)
      resolve(resultsData)
    })
  }

  static addReserve(result) {
    let index = deleteReserves.flatMap(r => [r.id]).indexOf(result.id)
    if (index > -1) {
      deleteReserves.splice(index, 1)
      return
    }

    addReserves.push(result)
  }

  static deleteReserve(result) {
    let index = addReserves.flatMap(r => [r.id]).indexOf(result.id)
    if (index > -1) {
      addReserves.splice(index, 1)
      return
    }

    deleteReserves.push(result)
  }

  static async commit(user, results) {
    let batch = firebase.firestore().batch()
    let resultRef = firebase.firestore().collection("users").doc(user.id).collection("results")

    addReserves.forEach(r => {
      let id = resultRef.doc().id
      console.log("add: " + id)
      batch.set(resultRef.doc(id), r.data)
    })

    deleteReserves.forEach(r => {
      console.log("delete: " + r.id)
      batch.delete(resultRef.doc(r.id))
    })

    let remains = results.filter(r => !addReserves.includes(r))
    remains = remains.filter(r => !deleteReserves.includes(r))
    remains.forEach(r => {
      console.log("update: " + r.id)
      batch.update(resultRef.doc(r.id), r.data)
    })

    await batch
      .commit()
      .then(() => {
        console.log("success")
      })
      .catch(e => {
        throw new Error(e)
      })
    
    ResultRepository.reset()
  }

  static reset() {
    addReserves = []
    deleteReserves = []
  }
}
